<template>
    <div class="sidebar-detail">
        <div class="detail-header-container">
            <h4 class="page-title">{{detailInfo.name}}</h4>
            <div class="round-btn" @click="closeDetailPage()" v-if="!disableDetailBtn"><i class="fas fa-times"></i></div>
        </div>

        <p class="detail-title">Statistics</p>
        <table class="recording-detail-table" >
            <tr v-if="detailInfo.columnInfo.sum != null">
                <td>Sum</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.sum, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.mean != null">
                <td>Mean</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.mean, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.median != null">
                <td>Median</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.median, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.min != null">
                <td>Min</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.min, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.max != null">
                <td>Max</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.max, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.minDate != null">
                <td>Min Date</td>
                <td>{{ $_getDateTimeFormat(detailInfo.columnInfo.minDate) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.maxDate != null">
                <td>Max Date</td>
                <td>{{ $_getDateTimeFormat(detailInfo.columnInfo.maxDate) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.standardDeviation != null">
                <td>Standard Deviation</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.standardDeviation, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.coefficientofVariation != null">
                <td>Coefficient of Variation (CV)</td>
                <td>{{ $_roundOfDecimal(detailInfo.columnInfo.coefficientofVariation, 2) }}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.uniqueValues != null">
                <td>Unique Values</td>
                <td>{{detailInfo.columnInfo.uniqueValues}}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.missingValues != null">
                <td>Missing Values</td>
                <td>{{detailInfo.columnInfo.missingValues}}</td>
            </tr>
            <tr v-if="detailInfo.columnInfo.featureType != null">
                <td>Input Type</td>
                <td>{{detailInfo.columnInfo.featureType}}</td>
            </tr>
        </table>
        <br>
        
        <p class="detail-title">Visualizations</p>
        <!-- <expand-mini-bar-chart :seriesData="detailInfo.columnInfo.chartData" :category="detailInfo.columnInfo.categories"></expand-mini-bar-chart> -->
        <expand-mini-box-plot-chart-2 
            v-if="checkIsShowingBoxplotChart()" 
            :chartId="getFieldId()" 
            :seriesData="detailInfo.columnInfo.boxplotData" 
            :outlierData="detailInfo.columnInfo.outliers" 
            :itemInfo="detailInfo.columnInfo"
        ></expand-mini-box-plot-chart-2>

        <expand-mini-bar-chart 
            v-else 
            :seriesData="detailInfo.columnInfo.chartData" 
            :category="detailInfo.columnInfo.categories"
        ></expand-mini-bar-chart>
        <!-- <expand-mini-box-plot-chart v-else :seriesData="detailInfo.series" chartId="BoxPlotChart"></expand-mini-box-plot-chart> -->
    </div>
</template>

<script>
import DetailButton from '@/components/Button/DetailButton'
import { compareValues } from '@/utils/sort-value'
import ExtensionDataDetail from '@/components/ExtensionDataDetail'
import { subjectGet } from '@/api/subject'
import ExpandMiniBarChart from '@/components/Analytics/ExpandMiniBarChart'
import ExpandMiniBoxPlotChart from '@/components/Analytics/ExpandMiniBoxPlotChart'
import ExpandMiniBoxPlotChart2 from '@/components/Analytics/ExpandMiniBoxPlotChart2'

    export default {
        components: {
            'extension-data-detail': ExtensionDataDetail,
            'detail-btn': DetailButton,
            'expand-mini-bar-chart': ExpandMiniBarChart,
            'expand-mini-box-plot-chart': ExpandMiniBoxPlotChart,
            'expand-mini-box-plot-chart-2': ExpandMiniBoxPlotChart2,
        },
        props: {
            infoSidebarId: {
                type: Number | String
            },
            disableDetailBtn: {
                type: Boolean,
                default: false
            },
            detailInfo: {
                type: Object
            }
        },
        methods: {
            checkIsShowingBoxplotChart() {
                if(this.detailInfo.columnInfo.chartType == 'BOX_PLOT' && (this.detailInfo.columnInfo.boxplotData && this.detailInfo.columnInfo.boxplotData.length > 0) ) {
                    return true
                }
                else return false   
            },
            closeDetailPage() {
                this.$store.dispatch('info_sidebar/setInfoSidebar');
            },
            getFieldId() {
                let {customFieldId, fixedHeaderFieldId} = this.detailInfo.columnInfo
                let id = customFieldId ? customFieldId : fixedHeaderFieldId
                let chartId = `chart-${id}`
                return chartId
            }
        }
    }
</script>

<style lang="css" scoped>
.sidebar-detail p{
    margin: var(--space-8) 0;
}
.sidebar-detail ul li{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
}
.recording-detail-table tr td{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
    padding: var(--space-4) var(--space-8);
    color: var(--charcoal-black)
}

.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-title {
    color: var(--main-color-1);
    font-size: var(--detail-page-title);
}
.empty-text{
    color: var(--charcoal-black);
    padding-left: var(--space-16);
}
.parent-hierrachy-container {
    display: inline-block;
}
.parent-hierrachy-text, .parent-hierrachy-symbol {
    display: inline-block;
    font-size: var(--form-label-size);
    color: var(--main-color-2);
    font-weight: 700;
    cursor: pointer;
}
.parent-hierrachy-text:hover {
    text-decoration: underline;
}
.subject-detail-btn{
    margin: var(--space-4) var(--space-8);
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/DataColumnSummarySidebar.vue